import navDocsRu from '../navRu.yml'
import navDocsEn from '../navEn.yml'


const sectionListDocsRu = navDocsRu.map(
    item => ({
        ...item,
    }),
);

const sectionListDocsEn = navDocsEn.map(
    item => ({
        ...item,
    }),
);

export {
    sectionListDocsRu,
    sectionListDocsEn,
};
